import React from 'react';
import ExtrasLayout from '@/components/layout/ExtrasLayout';

const Terms: React.FC = () => {
  return (
    <ExtrasLayout title="Terms of Use">
      <h4 className="extra-page__heading">Acceptance of Terms</h4>
      <p>
        By accessing or using this website (the “Site”), you agree to be bound by these Terms of
        Use. If you do not agree, you should not access or use the Site.
      </p>
      <h4 className="extra-page__heading">Informational Purpose Only</h4>
      <p>
        The content on this Site is provided for general informational purposes only. Nothing on
        this Site constitutes investment advice, legal advice, tax advice, or a recommendation
        regarding any security or investment strategy.
      </p>
      <h4 className="extra-page__heading">No Offer or Solicitation</h4>
      <p>
        Nothing on this Site constitutes an offer to sell or a solicitation of an offer to
        purchase any security. Any such offer may be made only pursuant to definitive offering
        documents and only to eligible investors in jurisdictions where permitted by law.
      </p>
      <h4 className="extra-page__heading">Intellectual Property</h4>
      <p>
        All content on this Site, including text, images, graphics, logos, and design elements, is
        the property of Ephemera Partners, L.P. or its licensors and is protected by applicable
        intellectual property laws.
      </p>
      <p>
        You may not reproduce, distribute, modify, transmit, or otherwise use any content from
        this Site without prior written consent.
      </p>
      <h4 className="extra-page__heading">Permitted Use</h4>
      <p>
        You may access and use this Site solely for lawful, personal, and non-commercial purposes.
        You agree not to:
      </p>
      <ul>
        <li>misuse or interfere with the Site’s operation;</li>
        <li>attempt to gain unauthorized access to any systems;</li>
        <li>use automated tools to scrape or harvest content;</li>
        <li>misrepresent your affiliation with Ephemera Partners.</li>
      </ul>
      <h4 className="extra-page__heading">No Warranties</h4>
      <p>
        This Site and its content are provided “as is” and “as available.” Ephemera Partners makes
        no representations or warranties, express or implied, regarding the accuracy,
        completeness, or reliability of the information contained herein.
      </p>
      <h4 className="extra-page__heading">Limitation of Liability</h4>
      <p>
        To the fullest extent permitted by law, Ephemera Partners shall not be liable for any
        direct, indirect, incidental, consequential, or other damages arising from or related to
        the use of this Site or reliance on any information contained herein.
      </p>
      <h4 className="extra-page__heading">Third-Party Links</h4>
      <p>
        This website does not contain performance data, targeted returns, or projections, and
        should not be interpreted as implying any level of investment performance or results.This
        Site may contain links to third-party websites. Ephemera Partners is not responsible for
        the content, accuracy, or practices of such third parties.
      </p>
      <h4 className="extra-page__heading">Governing Law</h4>
      <p>
        These Terms of Use shall be governed by and construed in accordance with the laws of the
        State of Delaware, without regard to conflict-of-laws principles.
      </p>
      <h4 className="extra-page__heading">Changes to These Terms</h4>
      <p>
        Ephemera Partners reserves the right to amend these Terms of Use at any time. Continued
        use of the Site constitutes acceptance of any such changes.
      </p>
      <p className="extra-page__accent">© Ephemera Partners, L.P. All rights reserved.</p>
    </ExtrasLayout>
  );
};

export default Terms;
